import { Outlet } from 'react-router-dom';
import { Box } from '@mui/joy';
import { Bell, CloudSun, Buildings, CalendarBlank, CreditCard, Database, EnvelopeSimple, Handshake, Receipt, Ruler, ShieldCheck, SlidersHorizontal, Tag, User, Users } from '@phosphor-icons/react';
import { useAuth } from '../../contexts/AuthContext';
import { isAffiliate, isSuperAdmin } from '../../utils/affiliate';
import { useSchedulingEnabled } from '../../hooks/useFeatureFlag';
import { WorkspaceNavigation, type WorkspaceGroup } from '../../components/common/WorkspaceNavigation';

export const SettingsAppUnified = () => {
  const { user } = useAuth();
  const { data: schedulingEnabled = false } = useSchedulingEnabled();
  const groups: WorkspaceGroup[] = [
    { label: 'Your account', items: [
      { label: 'Profile & email', to: '/settings/profile', icon: <User /> },
      { label: 'Notifications', to: '/settings/notifications', icon: <Bell /> },
      ...(schedulingEnabled ? [{ label: 'Scheduling', to: '/settings/scheduling', icon: <CalendarBlank /> }] : []),
    ] },
    { label: 'Organization', items: [
      { label: 'Company details', to: '/settings/organization', icon: <Buildings /> },
      ...(user?.is_organization_admin || user?.is_superuser ? [
        { label: 'Commissions', to: '/settings/commissions', icon: <Receipt /> },
        { label: 'Weather reports', to: '/settings/weather-reports', icon: <CloudSun /> },
        { label: 'Users & permissions', to: '/settings/users', icon: <Users /> },
        { label: 'Roles', to: '/settings/roles', icon: <ShieldCheck /> },
        { label: 'Billing & subscription', to: '/settings/billing', icon: <CreditCard /> },
      ] : []),
    ] },
    { label: 'Tools & data', items: [
      { label: 'Communications', to: '/settings/communications', icon: <EnvelopeSimple /> },
      { label: 'Tags', to: '/settings/tags', icon: <Tag /> },
      { label: 'QuickBooks sync', to: '/settings/quickbooks', icon: <Receipt /> },
      ...(user?.is_organization_admin ? [{ label: 'Material takeoff', to: '/settings/takeoff', icon: <Ruler /> }] : []),
      { label: 'Import data', to: '/settings/imports', icon: <Database /> },
    ] },
    { label: 'Administration', items: [
      ...(isAffiliate(user) ? [{ label: 'Affiliate program', to: '/settings/affiliate', icon: <Handshake /> }] : []),
      ...(isSuperAdmin(user) ? [{ label: 'System admin', to: '/settings/admin', icon: <SlidersHorizontal /> }] : []),
    ] },
  ];
  return <Box sx={{ p: { xs: 1.5, md: 3 }, width: '100%', minWidth: 0 }}>
    <WorkspaceNavigation title="Settings" description="Manage your account and company workspace." groups={groups}><Outlet /></WorkspaceNavigation>
  </Box>;
};
